import React from 'react';
import classnames from 'classnames';
import SVG, { SVGProps } from './SVGWrapper';
import { NavNotesIcon, NavRemindersIcon } from '.';

export const SearchIcon = ({ width = 14, height = 14, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('tour-tip-search-icon', props.className)}
    viewBox="-1 -1 14 14"
  >
    <g strokeWidth="1.6" fill="none">
      <circle cx="6" cy="6" r="6" />
      <circle cx="6" cy="6" r="2.2" />
    </g>
  </SVG>
);

export const TagIcon = ({ width = 12, height = 14, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('tour-tip-tag-icon', props.className)}
    viewBox="-1 -1 12 14"
  >
    <path
      fill="none"
      strokeWidth="1.37"
      strokeLinecap="round"
      d="M0 4H10M0 8H10M3.75 0L2.5 12M7.5 0L6.25 12"
    />
  </SVG>
);

export const AsperandIcon = ({
  width = 13,
  height = 13,
  color = 'primary',
  ...props
}: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('tour-tip-asperand-icon', props.className)}
    viewBox="0 0 14 14"
  >
    <path
      stroke="none"
      opacity="0.9"
      transform="translate(-5, -5)"
      d="M5,12 C5,13.1 5.2,14.1 5.5,14.9 C5.9,15.8 6.4,16.5 7,17.1 C7.7,17.7 8.4,18.2 9.3,18.5 C10.2,18.8 11.1,19 12.2,19 C12.7,19 13.3,19 13.7,18.9 C14.2,18.8 14.6,18.8 14.9,18.7 C15.2,18.6 15.3,18.5 15.4,18.4 C15.5,18.3 15.6,18.1 15.6,18 C15.6,17.9 15.5,17.8 15.4,17.7 C15.3,17.6 15.2,17.6 15.1,17.6 C15,17.6 15,17.6 14.9,17.6 C14.9,17.6 14.8,17.6 14.7,17.6 C14.3,17.7 14,17.8 13.6,17.8 C13.3,17.9 12.8,17.9 12.4,17.9 C11.5,17.9 10.6,17.8 9.9,17.5 C9.1,17.2 8.5,16.9 7.9,16.4 C7.4,15.9 7,15.2 6.7,14.5 C6.4,13.8 6.2,13 6.2,12.1 C6.2,11.2 6.4,10.4 6.7,9.6 C6.9,8.9 7.3,8.3 7.9,7.8 C8.4,7.2 9,6.8 9.7,6.5 C10.4,6.2 11.2,6.1 12.1,6.1 C12.9,6.1 13.7,6.2 14.3,6.4 C15,6.7 15.6,7 16.2,7.5 C16.7,7.9 17.1,8.5 17.4,9.1 C17.7,9.8 17.9,10.5 17.9,11.4 C17.9,12.3 17.7,13.1 17.4,13.7 C17.1,14.3 16.7,14.6 16.1,14.6 C15.8,14.6 15.5,14.5 15.3,14.3 C15.1,14.1 15,13.8 15,13.5 L15,9.1 C15,8.7 14.8,8.5 14.4,8.5 C14.2,8.5 14.1,8.6 14,8.7 C13.9,8.8 13.8,9 13.8,9.1 L13.8,9.8 L13.7,9.8 C13.6,9.4 13.3,9.1 12.9,8.9 C12.5,8.6 12.1,8.5 11.6,8.5 C11,8.5 10.5,8.7 10,9 C9.6,9.3 9.2,9.7 9,10.2 C8.7,10.7 8.6,11.4 8.6,12.1 C8.6,12.8 8.7,13.4 9,13.9 C9.3,14.4 9.6,14.9 10.1,15.2 C10.5,15.5 11,15.6 11.6,15.6 C12.1,15.6 12.6,15.5 13,15.2 C13.3,15 13.6,14.6 13.8,14.2 L13.9,14.2 C14,14.6 14.2,15 14.6,15.2 C14.9,15.5 15.4,15.6 15.9,15.6 C16.5,15.6 17.1,15.4 17.6,15.1 C18,14.7 18.4,14.2 18.6,13.5 C18.9,12.9 19,12.1 19,11.3 C19,10.3 18.8,9.5 18.5,8.7 C18.2,7.9 17.7,7.3 17.1,6.7 C16.5,6.2 15.7,5.7 14.9,5.4 C14.1,5.1 13.1,5 12.1,5 C11.1,5 10.1,5.2 9.3,5.5 C8.4,5.8 7.6,6.3 7,6.9 C6.4,7.5 5.9,8.3 5.5,9.1 C5.2,10 5,11 5,12 Z M11.8,14.5 C11.5,14.5 11.1,14.4 10.8,14.2 C10.6,14 10.3,13.7 10.2,13.4 C10,13 10,12.6 10,12.1 C10,11.6 10,11.1 10.2,10.8 C10.3,10.4 10.6,10.1 10.8,9.9 C11.1,9.7 11.5,9.6 11.8,9.6 C12.4,9.6 12.9,9.8 13.3,10.3 C13.6,10.7 13.8,11.3 13.8,12 C13.8,12.5 13.7,13 13.5,13.3 C13.4,13.7 13.2,14 12.9,14.2 C12.6,14.4 12.2,14.5 11.8,14.5 Z"
    />
  </SVG>
);

export const NotesIcon = ({ width = 12, height = 16, color = 'primary', ...props }: SVGProps) => (
  <NavNotesIcon
    className={classnames('tour-tip-notes-icon', props.className)}
    {...{ ...props, color, width, height }}
  />
);

export const RemindersIcon = ({
  width = 12,
  height = 16,
  color = 'primary',
  ...props
}: SVGProps) => (
  <NavRemindersIcon
    className={classnames('tour-tip-reminders-icon', props.className)}
    {...{ ...props, color, width, height }}
  />
);

export const PersonIcon = ({ width = 12, height = 13, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('tour-tip-person-icon', props.className)}
    viewBox="-1 -0.1 12 13"
  >
    <g opacity="0.9" strokeWidth="1.4" fill="none">
      <path d="M5,7.4 C7.5,7.4 10,10.9 10,11.3 C10,11.7 7.5,12 5,12 C2.5,12 0,11.7 0,11.3 C0,10.9 2.5,7.4 5,7.4Z" />
      <ellipse cx="5" cy="2.9" rx="2.16" ry="2.2" />
    </g>
  </SVG>
);

export const StarIcon = ({ width = 16, height = 16, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('tour-tip-star-icon', props.className)}
    viewBox="2 2 10 10"
  >
    <path
      stroke="none"
      opacity="0.9"
      d="M7 9.25l2.7 1.4l-0.5 -2.9l2.1 -2.1l-3 -0.5l-1.3 -2.6l-1.3 2.6l-3 0.5l2.1 2.1l-0.5 2.9z"
    />
  </SVG>
);

export const ProfileIcon = ({ width = 16, height = 16, color = 'primary', ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, color }}
    className={classnames('tour-tip-profile-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <circle stroke="none" opacity="0.4" cx="8" cy="8" r="8" />
    <circle stroke="none" opacity="0.9" cx="8" cy="8" r="3.8" />
  </SVG>
);
